import React, { useState } from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Card,
  CardBody,
  Label,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import '../../assets/css/LoginForm.css';
import bg from '../../assets/images/bg.jpg';
import logo from '../../assets/images/logo.png';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { authActions } from '../../sagas/authSlice';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { FaLock, FaUser } from 'react-icons/fa';
import NumericKeypad from './NumericKeypad';

const LoginForm = () => {
  const [activeField, setActiveField] = useState('username');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: { username: '', password: '' },
    onSubmit: (values) => {
      dispatch(
        authActions.loginRequest({
          user: values,
          onSuccess: (data) => {
            if (data.role === 'ROLE_MANAGER' || data.role === 'ROLE_ADMIN' || data.role === 'ROLE_SUPER_ADMIN') navigate('/modules');
            else if (data.role === 'ROLE_CAISSE') navigate('/comptoire');
            else navigate('/sales');
          },
          onError: () => {
            Swal.fire({ icon: 'error', title: t('auth.loginError') });
          },
        })
      );
    },
  });

  const handleKeyPress = (digit) => {
    formik.setFieldValue(activeField, (formik.values[activeField] || '') + digit);
  };

  const handleDelete = () => {
    formik.setFieldValue(activeField, (formik.values[activeField] || '').slice(0, -1));
  };

  const handleClear = () => {
    formik.setFieldValue(activeField, '');
  };

  return (
    <div className="auth-wrapper">
      <div
        className="auth-background auth-background-login"
        style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,0.55), rgba(255,255,255,0.55)), url(${bg})`,
        }}
      />

      <div className="auth-container">
        <Card className="login-card login-card-pos glass">
          <CardBody className="login-card-body login-card-body-pos">
            <div className="login-header login-header-pos">
              <img src={logo} alt="MatjarPOS" className="login-logo-small login-logo-pos" />
              <p className="login-subtitle mb-0">{t('auth.loginPrompt')}</p>
            </div>

            <Form onSubmit={formik.handleSubmit} className="login-form-pos">
              <FormGroup className="modern-form-group">
                <Label>{t('auth.username')}</Label>
                <div
                  className={`modern-input pos-modern-input ${activeField === 'username' ? 'is-active' : ''}`}
                  onClick={() => setActiveField('username')}
                >
                  <FaUser />
                  <Input
                    readOnly
                    inputMode="none"
                    value={formik.values.username}
                    placeholder="Code utilisateur"
                  />
                </div>
              </FormGroup>

              <FormGroup className="modern-form-group">
                <Label>{t('auth.password')}</Label>
                <div
                  className={`modern-input pos-modern-input ${activeField === 'password' ? 'is-active' : ''}`}
                  onClick={() => setActiveField('password')}
                >
                  <FaLock />
                  <Input
                    type="password"
                    readOnly
                    inputMode="none"
                    value={formik.values.password}
                    placeholder="PIN"
                  />
                </div>
              </FormGroup>

              <Button type="submit" className="login-button-modern login-button-pos">
                {t('auth.loginButton')}
              </Button>
            </Form>

            <div className="keypad-wrap-pos">
              <NumericKeypad
                onPress={handleKeyPress}
                onDelete={handleDelete}
                onClear={handleClear}
              />
            </div>

            <div className="auth-footer">&copy; {new Date().getFullYear()} MatjarPOS</div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default LoginForm;
